import { useEffect, useState } from 'react';

const useHubSpotChat = () => {
  const [isChatLoaded, setIsChatLoaded] = useState(false);

  useEffect(() => {
    // Poll until HubSpotConversations is available
    const interval = setInterval(() => {
      if (window.HubSpotConversations && window.HubSpotConversations.widget) {
        clearInterval(interval);
        setIsChatLoaded(true);
      }
    }, 500);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  const openChat = (options?: { widgetOpen: boolean }) => {
    if (isChatLoaded) {
      window.HubSpotConversations.widget.open(options);
    } else {
      console.error('HubSpot chat widget is not ready yet.');
    }
  };

  const refreshChat = (options?: { openToNewThread: boolean }) => {
    if (isChatLoaded) {
      window.HubSpotConversations.widget.refresh(options);
    } else {
      console.error('HubSpot chat widget is not ready yet.');
    }
  };

  return { openChat, refreshChat };
};

export { useHubSpotChat };
